interface ICheckmark {
  color?: string;
  width?: number;
  height?: number;
  className?: string;
}

export const Checkmark = ({ color = 'black', width, height, className }: ICheckmark) => (
  <svg
    className={className}
    width={width || 10}
    height={height || 8}
    viewBox="0 0 11 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-qa="checkmark"
  >
    <line
      x1="0.75"
      y1="-0.75"
      x2="4.77762"
      y2="-0.75"
      transform="matrix(0.710665 0.703531 -0.710665 0.703531 0 4.11121)"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <line
      x1="0.75"
      y1="-0.75"
      x2="9.19972"
      y2="-0.75"
      transform="matrix(0.710665 -0.703531 0.710665 0.703531 3.92871 8)"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
